module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICA8cGF0aCBkPSJNMTIgM0g1YTIgMiAwIDAgMC0yIDJ2MTRhMiAyIDAgMCAwIDIgMmgxNGEyIDIgMCAwIDAgMi0yVjEyIj48L3BhdGg+CiAgCiAgPHBvbHlsaW5lIHBvaW50cz0iMTcgMyAyMSAzIDIxIDciPjwvcG9seWxpbmU+CiAgPGxpbmUgeDE9IjE0IiB5MT0iMTAiIHgyPSIyMSIgeTI9IjMiPjwvbGluZT4KPC9zdmc+Cgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/internal-link-icon.svg
// module id = 2757
// module chunks = 0